/*
 * Toast. One global entry point, window.calmlyteToast(message, tone).
 *
 * Nothing here can throw into its caller. A toast reports a failure; if the
 * reporting throws, the failure it was reporting is replaced by a second,
 * less useful one, and the caller's own recovery path never runs.
 */
(function () {
  'use strict';

  var HOLD = 6000;
  var timer = null;

  function node() {
    return document.querySelector('[data-toast]');
  }

  function hide(el) {
    el.hidden = true;
    el.classList.remove('is-visible');
  }

  window.calmlyteToast = function (message, tone) {
    try {
      var el = node();
      if (!el || !message) return;

      var text = el.querySelector('[data-toast-text]');
      if (text) text.textContent = message;

      el.dataset.tone = tone === 'error' ? 'error' : 'ok';
      el.hidden = false;
      /* Force a reflow so the transition runs on a node that was display:none
         a moment ago; without it the toast appears at its final opacity. */
      void el.offsetWidth;
      el.classList.add('is-visible');

      window.clearTimeout(timer);
      timer = window.setTimeout(function () { hide(el); }, HOLD);
    } catch (e) {
      /* Last resort: the message still reaches somewhere a developer can find
         it, and the caller is unaffected. */
      if (window.console) console.warn('[calmlyte] toast failed:', message, e);
    }
  };

  document.addEventListener('click', function (event) {
    var el = node();
    if (!el || el.hidden) return;
    if (el.contains(event.target)) hide(el);
  });
})();
